<template>
    <div>
        <v-container fill-height fluid grid-list-xl class="pl-3 pt-0">
            <v-layout wrap>
                <v-flex xs8>
                    <v-card
                        class="mt-3 pb-2"
                        style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
                    >
                        <v-layout row justify-space-between>
                            <v-layout column class="ma-1 px-3">
                                <v-card-title
                                    class="pb-0 pt-3 pl-0"
                                    primary-title
                                >
                                    <div>
                                        <h3
                                            class="headline my-0 pt-2 ml-2 pl-1"
                                            v-if="account && account.id"
                                        >
                                            Family ID: {{ account.id }}
                                        </h3>
                                    </div>
                                </v-card-title>
                                <v-card-text
                                    class="mb-0 pb-0 pt-0"
                                    v-if="account && account.id"
                                >
                                    <div class="ml-2 mt-4">
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Play Name:
                                            </div>
                                            <div>
                                                {{ account.playName }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Hbrew Name:
                                            </div>
                                            <div>
                                                {{ account.nameY }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Site:
                                            </div>
                                            <div>
                                                {{ account.site }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Bungalow:
                                            </div>
                                            <div>
                                                {{ account.bungalow }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Phone Number:
                                            </div>
                                            <div>
                                                {{ account.phoneNumber }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Pin:
                                            </div>
                                            <div>
                                                {{ account.pin }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Allow Change:
                                            </div>
                                            <div>
                                                {{
                                                    account.allowChange
                                                        ? "Yes"
                                                        : "No"
                                                }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                No Box:
                                            </div>
                                            <div>
                                                {{
                                                    account.noBox ? "Yes" : "No"
                                                }}
                                            </div>
                                        </v-layout>
                                        <v-layout
                                            row
                                            class="mb-2"
                                            v-if="account.note"
                                        >
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Note:
                                            </div>
                                            <div>
                                                {{ account.note }}
                                            </div>
                                        </v-layout>
                                        <v-layout
                                            row
                                            class="mb-2"
                                            v-if="account.labelNote"
                                        >
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Label Note:
                                            </div>
                                            <div>
                                                {{ account.labelNote }}
                                            </div>
                                        </v-layout>
                                    </div>
                                </v-card-text>
                            </v-layout>

                            <v-spacer></v-spacer>

                            <v-layout
                                justify-space-between
                                column
                                align-end
                                fill-height
                                class="mb-0 mr-3"
                            >
                                <v-btn
                                    class="mt-0 mb-3 mr-1"
                                    color="success"
                                    small
                                    dark
                                    @click="openEditDialog"
                                >
                                    Edit
                                </v-btn>
                            </v-layout>
                        </v-layout>
                    </v-card>

                    <v-card
                        class="pa-3 mt-3"
                        style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
                    >
                        <v-tabs color="success" dark icons-and-text>
                            <v-tabs-slider color="#fff"></v-tabs-slider>

                            <v-tab href="#menu">
                                Menu Items ({{ menuItems.length }})
                                <v-icon>mdi-food</v-icon>
                            </v-tab>

                            <v-tab href="#logs">
                                Logs ({{ logs.length }})
                                <v-icon>mdi-swap-horizontal</v-icon>
                            </v-tab>

                            <v-tab href="#requests">
                                Requests ({{ requests.length }})
                                <v-icon>mdi-message-alert</v-icon>
                            </v-tab>

                            <v-tab href="#ivrcalls">
                                IVR Calls ({{ getIvrCallsCount() }})
                                <v-icon>mdi-phone</v-icon>
                            </v-tab>

                            <v-spacer></v-spacer>

                            <v-select
                                style="width: 100px;"
                                class="mr-3 px-3 mt-2"
                                @change="distributionChanged"
                                :items="distributions.map((d) => d.week)"
                                v-model="distributionName"
                                hide-details
                            ></v-select>

                            <v-tab-item value="menu">
                                <v-card class="pa-2 my-2">
                                    <div class="headline mb-3">Menu</div>
                                    <div v-for="(item, index) in menuItems">
                                        <v-layout row class="px-3 my-0">
                                            <div
                                                style="width: 30%"
                                                class="pt-2"
                                            >
                                                <span
                                                    class="font-weight-medium mr-2"
                                                    >Item:</span
                                                >
                                                {{ item.menuItemName }}
                                            </div>

                                            <div
                                                style="width: 15%"
                                                class="pt-2 text--disabled body-2"
                                            >
                                                <span
                                                    class="font-weight-regular mr-2"
                                                    >Max Input:</span
                                                >
                                                {{ item.maxInput || "" }}
                                            </div>
                                            <div
                                                style="width: 15%"
                                                class="pt-2"
                                            >
                                                <span
                                                    class="font-weight-medium mr-2"
                                                    >Quantity:</span
                                                >
                                                <span
                                                    v-bind:class="{
                                                        'text-danger':
                                                            item.isChanged,
                                                    }"
                                                    >{{
                                                        item.quantity || 1
                                                    }}</span
                                                >
                                            </div>
                                            <v-select
                                                v-if="
                                                    item.editing &&
                                                        item.choices &&
                                                        item.choices.length
                                                "
                                                class="ml-4 mr-2"
                                                v-model="item.quantity"
                                                label="Quantity"
                                                hide-details
                                                @change="
                                                    changeQuantity($event, item)
                                                "
                                                :items="
                                                    item.choices.map(
                                                        (i) => i.choice,
                                                    )
                                                "
                                            ></v-select>
                                            <v-text-field
                                                v-if="item.editing"
                                                class="mr-4"
                                                v-bind:class="{
                                                    'pt-0 pb-2':
                                                        !item.choices ||
                                                        !item.choices.length,
                                                }"
                                                v-model="item.quantity"
                                                label="Quantity"
                                                hide-details
                                            ></v-text-field>
                                            <v-btn
                                                class="my-0 "
                                                v-if="!item.editing"
                                                @click.stop="editItem(item)"
                                                flat
                                                icon
                                                color="success"
                                            >
                                                <v-icon>mdi-pencil</v-icon>
                                            </v-btn>
                                            <v-btn
                                                class="mb-0 mt-2 ml-2"
                                                style="height: 28px;"
                                                v-if="item.editing"
                                                @click.stop="rollbackItem(item)"
                                                small
                                                dark
                                                color="default"
                                                >Cancel
                                            </v-btn>
                                            <v-btn
                                                class="mb-0 mt-2"
                                                style="height: 28px;"
                                                v-if="item.editing"
                                                @click.stop="saveMenuItem(item)"
                                                small
                                                color="success"
                                                >Save
                                            </v-btn>
                                        </v-layout>
                                        <v-divider></v-divider>
                                    </div>
                                </v-card>
                            </v-tab-item>
                            <v-tab-item value="logs">
                                <v-card class="pa-2 my-2">
                                    <!-- <div class="headline mb-3">Logs</div> -->
                                    <div v-for="(log, index) in logs">
                                        <v-layout row class="px-3 pt-3">
                                            <div class="pt-2 mr-3">
                                                <span
                                                    class="font-weight-medium mr-2"
                                                    >Date:</span
                                                >
                                                {{ log.date | time }}
                                            </div>
                                            <div class="pt-2 mr-3">
                                                <span
                                                    class="font-weight-medium mr-2"
                                                    >Changed By:</span
                                                >
                                                {{ log.userName }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="px-3 my-0 pb-2">
                                            <div class="mr-3">
                                                <span
                                                    class="font-weight-medium mr-2"
                                                    >Item:</span
                                                >
                                                {{ getLogItem(log) }}
                                            </div>
                                            <div class="mr-3">
                                                <span
                                                    class="font-weight-medium mr-2"
                                                    >Choice:</span
                                                >
                                                {{ getLogItemChoice(log) }}
                                            </div>
                                        </v-layout>
                                        <v-divider></v-divider>
                                    </div>
                                </v-card>
                            </v-tab-item>
                            <v-tab-item value="requests">
                                <account-requests
                                    :requests="requests"
                                    :account="account"
                                ></account-requests>
                            </v-tab-item>
                            <v-tab-item value="ivrcalls">
                                <account-ivr-calls
                                    ref="ivrCalls"
                                ></account-ivr-calls>
                            </v-tab-item>
                        </v-tabs>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="updateAccountDialog" max-width="400" persistent>
            <v-card class="pa-3">
                <v-card-title class="headline px-0 mb-3 py-0"
                    >Update Family</v-card-title
                >
                <v-form ref="form">
                    <v-text-field
                        autocomplete="new-password"
                        label="Name"
                        v-model="accountToEdit.playName"
                        ref="playName"
                        :rules="[rules.required]"
                    ></v-text-field>
                    <v-text-field
                        autocomplete="new-password"
                        label="Hebrew Name"
                        v-model="accountToEdit.nameY"
                        ref="hebName"
                        :rules="[rules.required]"
                    ></v-text-field>
                    <v-select
                        label="Site"
                        v-model="accountToEdit.site"
                        ref="site"
                        :rules="[rules.required]"
                        :items="sites.map((c) => c.campNameEng)"
                    ></v-select>
                    <v-text-field
                        autocomplete="new-password"
                        label="Bungalow"
                        v-model="accountToEdit.bungalow"
                        ref="bungalow"
                        :rules="[rules.required]"
                    ></v-text-field>
                    <v-text-field
                        autocomplete="new-password"
                        label="Phone Number"
                        v-model="accountToEdit.phoneNumber"
                        ref="phoneNumber"
                        :rules="[rules.phoneNumber]"
                    ></v-text-field>
                    <v-text-field
                        autocomplete="new-password"
                        label="Note"
                        v-model="accountToEdit.note"
                        ref="note"
                    ></v-text-field>
                    <v-text-field
                        autocomplete="new-password"
                        label="Label Note"
                        v-model="accountToEdit.labelNote"
                        ref="labelNote"
                    ></v-text-field>
                    <v-switch
                        color="success"
                        class="mt-0"
                        v-model="accountToEdit.allowChange"
                        label="Allow Change"
                    ></v-switch>
                    <v-switch
                        color="success"
                        class="mt-0"
                        v-model="accountToEdit.noBox"
                        label="No Box"
                    ></v-switch>
                </v-form>
                <v-card-actions class="mr-0 mt-2 py-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="updateAccountDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveAccount"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { groupBy, formatPhoneNumber } from "../../utils/helpers.js";
import accountRequests from "./YkCampDistributionAccountRequests.vue";
import accountIvrCalls from "./YkCampDistributionAccountIVRCalls.vue";
//import foodDistributionIvrCalls from "./Components/FoodDistributionIvrCalls.vue";
import moment from "moment";

export default {
    components: {
        accountRequests,
        accountIvrCalls,
        // foodDistributionIvrCalls,
    },
    data: () => ({
        account: null,
        updateMenuDialog: false,
        menuItems: [],
        logs: [],
        choices: [],
        requests: [],
        processing: false,
        updateAccountDialog: false,
        accountToEdit: "",
        distributions: [],
        distributionName: "",
        distributionID: "",
        sites: [],

        rules: {
            required: (v) => {
                return !!v || "Required";
            },
            phoneNumber: (v) => {
                return (
                    !v ||
                    ([10, 11].includes(v.replace(/-/g, "").length) &&
                        /^\d+$/.test(v.replace(/-/g, ""))) ||
                    "Invalid Phone Number"
                );
            },
        },
    }),
    async created() {
        await this.loadAccount();
        await this.loadDistributions();
        await this.loadMenu();
        await this.loadRequests();
        await this.loadLogs();
        await this.loadSites();
    },
    methods: {
        async loadAccount() {
            const account = await this.$http.get(
                "api/campDistribution/GetByID?familyID=" +
                    this.$route.params.id,
            );
            this.account = account;
        },
        async loadDistributions() {
            const response = await this.$http.get(
                "api/campDistribution/GetDistributionSelectionList",
            );

            this.distributions = response;

            if (this.$route.query.distributionID) {
                const distribution = this.distributions.find(
                    (d) => d.id == this.$route.query.distributionID,
                );
                this.distributionName = distribution.week;
                this.distributionID = this.$route.query.distributionID;
            } else {
                const first = this.distributions[0];

                this.distributionName = first.week;
            }
        },
        async loadSites() {
            const sites = await this.$http.get(
                "api/campDistribution/getCampInfo",
            );

            this.sites = sites;
        },
        getCampID(campName) {
            return this.sites.find((c) => c.campNameEng == campName).id;
        },
        distributionChanged(value) {
            this.distributionID = this.distributions.find(
                (d) => d.week == value,
            ).id;

            this.loadMenu();
            this.loadLogs();
        },
        async loadMenu() {
            const response = await this.$http.get(
                "api/campDistribution/getMenu?familyID=" +
                    this.$route.params.id +
                    "&distributionID=" +
                    this.distributionID,
            );

            this.menuItems = response.menuItems.map((item) => {
                item.choices = response.choices.filter(
                    (c) => c.menuItemID == item.menuItemID,
                );
                item.editing = false;

                return item;
            });
            this.choices = response.choices;
        },
        async loadRequests() {
            const requests = await this.$http.get(
                "api/campDistribution/getRequests?familyID=" +
                    this.$route.params.id,
            );

            this.requests = requests;
        },
        async loadLogs() {
            const logs = await this.$http.get(
                "api/campDistribution/GetLogs?familyID=" +
                    this.$route.params.id +
                    "&distributionID=" +
                    this.distributionID,
            );

            this.logs = logs;
        },
        getLogItem(log) {
            const parts = log.data.split("|");
            const item = parts.find((p) => p.startsWith("MenuItemID"));
            const menuItemID = item.split(":")[1];

            const menuItem = this.menuItems.find(
                (m) => m.menuItemID == +menuItemID,
            );

            return menuItem ? menuItem.menuItemName : "";
        },
        getLogItemChoice(log) {
            const parts = log.data.split("|");
            const item = parts.find((p) => p.startsWith("Choice"));
            return item.split(":")[1];
        },
        editItem(item) {
            item.original = item.quantity;
            item.editing = true;
        },
        rollbackItem(item) {
            item.quantity = item.original;
            item.editing = false;
        },
        changeQuantity(event, item) {},
        async saveMenuItem(menuItem) {
            try {
                this.processing = true;

                await this.$http.post("api/campDistribution/SaveChoice", {
                    distributionID: this.distributionID,
                    choice: menuItem.quantity,
                    menuItemID: menuItem.menuItemID,
                    familyID: this.account.id,
                    user: this.$store.state.authentication.user,
                });

                this.processing = false;
                menuItem.editing = false;

                this.loadMenu();
                this.loadLogs();
            } catch (e) {
                this.processing = false;
            }
        },
        async saveAccount() {
            try {
                if (!this.$refs.form.validate()) return;

                this.processing = true;

                this.accountToEdit.campID = this.getCampID(
                    this.accountToEdit.site,
                );

                await this.$http.post(
                    "api/ykCampFamilies/save",
                    this.accountToEdit,
                );

                this.processing = false;
                this.updateAccountDialog = false;

                this.loadAccount();
            } catch (e) {
                this.processing = false;
            }
        },
        getIvrCallsCount() {
            if (this.$refs && this.$refs.ivrCalls)
                return this.$refs.ivrCalls.getCalls().length;

            return 0;
        },
        openEditDialog() {
            this.accountToEdit = JSON.parse(JSON.stringify(this.account));
            this.updateAccountDialog = true;
        },
    },
};
</script>
<style>
.v-expansion-panel__header {
    height: 63px;
}
.website-link-text {
    color: rgb(32, 166, 237);
    display: inline-block;
    word-wrap: break-word;
    width: 100%;
}
.distribution-list {
    border: 1px solid #ddd !important;
}
</style>
